import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d244876&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleHeader: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Article/Header.vue').default,ArticleFooter: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Article/Footer.vue').default,Article: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Article/index.vue').default})
